import { render } from "./DevelopmentAndTesting.vue?vue&type=template&id=1464f889&lang=true"
import script from "./DevelopmentAndTesting.vue?vue&type=script&lang=js"
export * from "./DevelopmentAndTesting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__